import { Controller } from '@hotwired/stimulus';


export default class extends Controller {
	static get targets () {
		return ['variant', 'clubSelect', 'clubSpaceRow', 'clubSpaceSection'];
	}

	connect() {
		this.onToggleChange = this.onToggleChange.bind(this);
		this.onClubDropdownChange = this.onClubDropdownChange.bind(this);
		document.addEventListener('plan-toggle:change', this.onToggleChange);
		this.element.addEventListener('club-selection-dropdown:change', this.onClubDropdownChange);

		if (this.hasClubSelectTarget) {
			this.filterClubSpaces(this.clubSelectTargets[0].value);
		}
	}

	disconnect() {
		document.removeEventListener('plan-toggle:change', this.onToggleChange);
		this.element.removeEventListener('club-selection-dropdown:change', this.onClubDropdownChange);
	}

	toggleSection(event) {
		const section = event.currentTarget.closest('.compare-plans__section, .compare-plans-m__section');
		const expanded = section.classList.toggle('active');

		if (event.currentTarget.hasAttribute('aria-expanded')) {
			event.currentTarget.setAttribute('aria-expanded', String(expanded));
		}
	}

	onClubDropdownChange(event) {
		const clubId = String(event.detail?.clubId || '');
		const source = event.target.querySelector('select');

		this.syncClubSelects(clubId, source);
		this.filterClubSpaces(clubId);
	}

	syncClubSelects(clubId, source) {
		if (!this.hasClubSelectTarget) {
			return;
		}

		this.clubSelectTargets.forEach((select) => {
			if (select === source) {
				return;
			}

			select.value = clubId;
			this.syncDropdownUi(select, clubId);
		});
	}

	syncDropdownUi(select, clubId) {
		const dropdown = select.closest('.club-selection-dropdown');

		if (!dropdown) {
			return;
		}

		const triggerLabel = dropdown.querySelector('[data-club-selection-dropdown-target="triggerLabel"]');
		const placeholder = dropdown.dataset.placeholder || '';
		const selectedOption = select.options[select.selectedIndex];

		if (triggerLabel) {
			triggerLabel.textContent = clubId && selectedOption ? selectedOption.textContent : placeholder;
		}

		dropdown.querySelectorAll('.club-selection-dropdown__club').forEach((club) => {
			const button = club.querySelector('[data-value]');
			club.classList.toggle('is-selected', Boolean(clubId) && button?.dataset.value === String(clubId));
		});
	}

	filterClubSpaces(clubId) {
		if (!this.hasClubSpaceRowTarget) {
			return;
		}

		let clubTagsMap = {};

		try {
			clubTagsMap = JSON.parse(this.element.dataset.clubTagsMap || '{}');
		} catch (error) {
			clubTagsMap = {};
		}

		const clubTags = (clubTagsMap[String(clubId)] || []).map(Number);

		this.clubSpaceRowTargets.forEach((row) => {
			if (!clubId) {
				row.hidden = true;
				return;
			}

			const required = (row.dataset.requiredTags || '').split(',').filter(Boolean).map(Number);
			row.hidden = required.length > 0
				? !required.some((id) => clubTags.includes(id))
				: false;
		});

		if (!this.hasClubSpaceSectionTarget) {
			return;
		}

		this.clubSpaceSectionTargets.forEach((section) => {
			const rows = this.clubSpaceRowTargets.filter((row) => section.contains(row));
			const anyVisible = rows.some((row) => !row.hidden);
			const hasPicker = Boolean(section.querySelector('.club-selection-dropdown'));
			section.hidden = !anyVisible && !hasPicker;

			const wrapper = section.querySelector('.compare-plans__wrapper');
			if (wrapper) {
				wrapper.hidden = !anyVisible;
			}
		});
	}

	onToggleChange(event) {
		const { toggleId, checked } = event.detail;
		const targetVariant = checked ? 'annual' : 'short';

		this.variantTargets.forEach((variant) => {
			if (variant.dataset.toggleId !== toggleId) {
				return;
			}

			variant.hidden = variant.dataset.variant !== targetVariant;
		});
	}
}
